const W = 1080;
const H = 1920;

const wrap = (ctx, text, maxW) => {
  const lines = [];
  let line = "";
  text.split(" ").forEach((word) => {
    const test = line ? `${line} ${word}` : word;
    if (ctx.measureText(test).width > maxW && line) { lines.push(line); line = word; } else line = test;
  });
  if (line) lines.push(line);
  return lines;
};

const drawLogo = (ctx, x, y, s) => {
  ctx.save();
  ctx.translate(x, y);
  ctx.scale(s, s);
  ctx.strokeStyle = "#E5C158";
  ctx.fillStyle = "#E5C158";
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.moveTo(9, 33); ctx.lineTo(9, 17); ctx.arc(20, 17, 11, Math.PI, 0); ctx.lineTo(31, 33);
  ctx.moveTo(6, 33); ctx.lineTo(34, 33);
  ctx.stroke();
  ctx.fillRect(13.5, 21, 3, 12); ctx.fillRect(18.5, 16, 3, 17); ctx.fillRect(23.5, 23, 3, 10);
  ctx.restore();
};

const render = async (quote, tag) => {
  await Promise.all([
    document.fonts.load('500 64px "Cormorant Garamond"'),
    document.fonts.load('italic 500 48px "Cormorant Garamond"'),
    document.fonts.load('400 26px "JetBrains Mono"'),
  ]);
  const c = document.createElement("canvas");
  c.width = W; c.height = H;
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#070A12";
  ctx.fillRect(0, 0, W, H);
  const g = ctx.createRadialGradient(200, 300, 0, 200, 300, 1100);
  g.addColorStop(0, "rgba(229,193,88,0.20)");
  g.addColorStop(1, "rgba(229,193,88,0)");
  ctx.fillStyle = g;
  ctx.fillRect(0, 0, W, H);
  ctx.strokeStyle = "rgba(243,229,171,0.25)";
  ctx.lineWidth = 2;
  ctx.strokeRect(60, 60, W - 120, H - 120);

  ctx.fillStyle = "rgba(229,193,88,0.35)";
  ctx.font = '500 420px "Cormorant Garamond"';
  ctx.fillText("\u201C", 110, 560);

  ctx.fillStyle = "#E5C158";
  ctx.font = '400 26px "JetBrains Mono"';
  ctx.fillText(tag.toUpperCase().split("").join(" "), 140, 600);

  let size = 72;
  let lines;
  do {
    ctx.font = `500 ${size}px "Cormorant Garamond"`;
    lines = wrap(ctx, quote, W - 280);
    size -= 4;
  } while (lines.length * size * 1.25 > 900 && size > 40);
  const lh = (size + 4) * 1.22;
  ctx.fillStyle = "#F8FAFC";
  lines.forEach((l, i) => ctx.fillText(l, 140, 720 + i * lh));

  const y = 720 + lines.length * lh + 70;
  ctx.fillStyle = "#E5C158";
  ctx.fillRect(140, y - 14, 80, 2);
  ctx.font = 'italic 500 48px "Cormorant Garamond"';
  ctx.fillText("Rinda Marbun", 245, y);

  drawLogo(ctx, 140, H - 260, 2.4);
  ctx.fillStyle = "rgba(243,229,171,0.8)";
  ctx.font = '400 24px "JetBrains Mono"';
  ctx.fillText("T H E   L E G A C Y   S H E L F", 250, H - 190);

  return new Promise((res) => c.toBlob(res, "image/png"));
};

export const shareQuoteImage = async (quote, tag, index) => {
  const blob = await render(quote, tag);
  const name = `kutipan-rinda-marbun-${index}.png`;
  const file = new File([blob], name, { type: "image/png" });
  if (navigator.canShare?.({ files: [file] }) && /Mobi|Android/i.test(navigator.userAgent)) {
    try { await navigator.share({ files: [file] }); return; } catch (e) { if (e?.name === "AbortError") return; }
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = name;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
};
